import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../hooks/useRootStore';
import { Box, Button, Link, TextField } from '@mui/material';
import { match } from 'ts-pattern';
import md5 from "md5";


const ResetPassword = observer(() => {

    const { api } = useRootStore();
    const [newPassword, setNewPassword] = useState(document.getElementById('password')?.nodeValue ?? '');
    const [confirm, setConfirm] = useState(document.getElementById('confirm')?.nodeValue ?? '');
    const [success, setSuccess] = useState<boolean | undefined>(undefined);

    const handleReset = () => {
        if (checkConfirm()) {
            api
                .resetPassword(md5(newPassword))
                .then(() => setSuccess(true))
                .catch(() => setSuccess(false));
        }
    };

    const checkConfirm = (): boolean => {
        return newPassword === confirm;
    }

    return (
        <div style={{ paddingTop: 50 }} >
            <Box sx={{ padding: "15px" }}>
                <TextField
                    type="password"
                    className="white"
                    id="password"
                    label="Новый пароль"
                    variant="outlined"
                    required
                    error={!checkConfirm()}
                    onChange={(e) => setNewPassword(e.target.value ?? '')}
                />
            </Box>
            <Box sx={{ padding: "15px" }}>
                <TextField
                    type="password"
                    className="white"
                    id="confirm"
                    label="Подтверждение"
                    variant="outlined"
                    required
                    error={!checkConfirm()}
                    onChange={(e) => setConfirm(e.target.value ?? '') }
                />
            </Box>
            <Box>
                <Button disabled={newPassword.trim() === '' || !checkConfirm()} onClick={handleReset}>Установить</Button>
            </Box>
            <Box sx={{ paddingTop: "15px" }}>
                {
                    match(success)
                        .with(true, () =>
                            <>
                                <Box sx={{ paddingTop: "15px" }}>
                                    Новый пароль успешно установлен
                                </Box>
                                <Box sx={{ paddingTop: "15px" }}>
                                    <Link href="./login">На страницу входа</Link>
                                </Box>
                            </>                                )
                        .with(false, () => 'Ошибка смены пароля')
                        .otherwise(() => '')
                }
            </Box>
        </div>
    );
});

export default ResetPassword;